import { ChangeEvent, FC, useEffect, useState } from "react";
import { Input, Button } from "@ht/components";
import { TInput } from "@ht/components/src/forms/form-elements/types";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { sendAgentMessage, typingAgentMessage, sendAgentOfflineMessage, removeAgentOfflineMessage, chatAgentWSConnecting } from "../../../app/chatAgent/chatAgentSlice";
import SendIcon from "@ht/shared/fonts/deos-pis/send";
import { IChat } from "../type";
import clsx from "clsx";

interface IProps {
    roomId: string;
}
const MessageFooter: FC<IProps> = ({ roomId }) => {
    const dispatch = useAppDispatch();
    const { connected, activeRoom, messages, status } = useAppSelector((state) => state.chatagent);
    const { user } = useAppSelector((state) => state.auth);
    const deviceId = user?.deviceId ?? "";
    const senderName = user?.username ?? "";
    const [text, setText] = useState("");

    const resendOfflineMessage = () => {
        const offlineMessages = messages.filter(a => !a.isSent);
        offlineMessages.map(item => {
            const newMessage = {
                deviceId: item.senderId,
                senderName: item.senderName,
                roomId: item.roomId,
                content: {
                    type: item.messageType,
                    message: item.message,
                    files: item.messageFiles
                },
                sessionId: item.sessionId,
            } as IChat;
            dispatch(sendAgentMessage(newMessage));
        });
    }
    useEffect(() => {
        if (status) {
            if (status.status == "SENT")
                dispatch(removeAgentOfflineMessage());
            else if (status.status == "HANDLEDROOM")
                resendOfflineMessage();
        }
    }, [status]);
    const sendTextMessage = (textMessage: string) => {
        const newMessage = {
            deviceId,
            senderName,
            roomId,
            content: {
                type: "TEXT",
                message: textMessage,
                files: []
            },
            sessionId: activeRoom.sessionId,
        } as IChat;

        if (connected) {
            dispatch(sendAgentMessage(newMessage));
        }
        else {
            dispatch(sendAgentOfflineMessage(newMessage));
            setTimeout(() => dispatch(chatAgentWSConnecting()), 1000);
        }
    }

    const submitHandler = (e: { preventDefault: () => void }) => {
        e.preventDefault();
        if (text.trim() != "") {
            sendTextMessage(text);
        }
        setText("");
    };
    const textHandler = (e: ChangeEvent<TInput>) => {
        setText(e.target.value);
        if (user) dispatch(typingAgentMessage({ sessionId: activeRoom.sessionId, userName: user.username }));
    };

    return (
        <div className="message-footer rounded-b bg-white px-5 h-[68px] flex items-center border-t border-gray-100">
            <form autoComplete="off"
                className="flex items-center justify-between flex-auto"
                onSubmit={submitHandler}>

                <div className="grow ">
                    <Input
                        id="message"
                        name="message"
                        placeholder="Type something here..."
                        className={clsx("!text-md !text-gray-700 placeholder-gray-400 border-none focus:bg-gray-100 rounded-l-md bg-gray-100 outline-none")}
                        onChange={textHandler}
                        value={text}
                    />
                </div>
                <div className="flex flex-none w-12">
                    <div className="bg-gray-100 flex">
                        <div className="border-l border-l-gray-200 my-1"></div>
                    </div>
                    <Button shape="square" type="submit" iconButton
                        className="!w-full h-10 bg-gray-100 hover:bg-gray-200 border-y-0 border-r-0 hover:border-l-gray-100 border-l-gray-100 rounded-r-md outline-none" >
                        <SendIcon className="text-gray-400" />
                    </Button>
                </div>
            </form>
        </div>
    );
};

export default MessageFooter;
